<template>
    <div class="l-app-main">
        <div class="l-app-main-inboxzero bg-primary-lighter" v-show="inboxzero">
            <h2>No contacts</h2>
            <p>Create a contact list to send SMS and<br />manage your contacts</p>
            <div class="padding-sm"></div>
            <button class="ui large bg-primary button" @click="createContactList()">Create Contact List</button>
            <div class="padding-xl"></div>
        </div>
        <div class="l-app-main-section" v-show="!inboxzero">
            <div class="l-app-main-section-container one">
                <div class="l-app-list-title">
                    <div class="ui middle aligned grid">
                        <div class="column">
                            <button class="ui bg-primary small fluid button" @click="createContactList()"> Add Contact List</button>
                        </div>
                    </div>
                </div>
    
                <ul class="l-app-list">
                    <li v-for="dataList in dataLists" v-bind:key="dataList.list_id" @click="selectList(dataList)" v-bind:class="{selected: selectedKey == dataList.contact_groupId}">{{dataList.list_name}}
                        <div class="status hidden"><i class="circle green icon"></i></div>
                        <div class="info">
                            <span class="info-title">{{dataList.group_name}}</span>
                            <span class="info-meta">{{dataList.total}} contacts</span>
                        </div>
                    </li>
                </ul>
    
                <div class="padding-md">
                    <div v-show="!loading" @click="getContactList()" class="ui fluid button bottom aligned button">Load More</div>
                </div>
                <loader v-show="loading"></loader>
            </div>
            <!--<div class="l-app-main-section-container two">
                <div class="ui relaxed padded grid">
                    <div class="middle aligned row">
                        <div class="six wide column">
                            <h3 class="text-green text-medium">Contact List Name</h3>
                            <h5 class="text-lightgrey">Updated 3 Aug 2018</h5>
                        </div>
                        <div class="ten wide right aligned column">
                            <button class="ui small button" id="upload-file-btn" :disabled="processingUploadFile">Upload File</button>
                            <button class="ui small bg-primary button">Send Message</button>
                            <div class="ui small icon floating dropdown button">
                                <i class="icon dropdown"></i>
                                <div class="ui menu">
                                    <a href="#" class="item" @click="editContactList()">Edit Contact List</a>
                                    <a href="#" class="item">Download Sample CSV</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-show="showUploadSection">
                        <div class="column">
                            <div class="ui secondary top attached segment">
                                <div class="ui bottom aligned grid">
                                    <div class="twelve wide left aligned column" id="droppedFile"></div>
                                    <div class="four wide right aligned column">
                                        <button class="ui bg-accent button" @click="uploadContacts">Save</button>
                                    </div>
                                </div>
                            </div>
                            <div class="ui bottom attached tiny indicating progress" id="uploadProgress" data-value="0" data-total="100">
                                <div class="bar"></div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-show="processingUploadFile">
                        <div class="column">
                            <div class="ui green message">
                                <i class="fa fa-spinner fa-spinning"></i> Processing file. This may take a few minutes.
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="column">
                            <div class="ui top attached segment">
                                <h2>123 <small class="text-lightgrey text-normal">contacts</small></h2>
                            </div>
                            <div class="ui bottom attached raised secondary segment">
                                <div class="ui equal width grid">
                                    <div class="column border-right">
                                        <h4 class="text-medium">123</h4>
                                        <h5>Safaricom</h5>
                                    </div>
                                    <div class="column border-right">
                                        <h4 class="text-medium">12</h4>
                                        <h5>Airtel</h5>
                                    </div>
                                    <div class="column">
                                        <h4 class="text-medium">1</h4>
                                        <h5>Telkom</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="column">
                            <div class="padding-top-md"></div>
                            <div class="ui equal width middle aligned grid">
                                <div class="column">
                                    <h3 class="text-medium">123 Contacts</h3>
                                </div>
                                <div class="right aligned column">
                                    <div class="ui search link input margin-right-md">
                                        <input type="text" placeholder="Search contact" />
                                    </div>
                                    <button class="ui icon button text-green"><i class="filter icon"></i> Filter</button>
                                </div>
                            </div>
                            <table class="ui styled celled table">
                                <thead>
                                    <tr>
                                        <th class="center aligned">#</th>
                                        <th>Pnone Number</th>
                                        <th>field_1</th>
                                        <th>field_2</th>
                                        <th>field_3</th>
                                        <th>field_4</th>
                                        <th>field_5</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="hidden">
                                        <td colspan="7" class="center aligned table-input-title">
                                            <i class="plus icon"></i> Add contacts
                                        </td>
                                    </tr>
                                    <tr class="">
                                        <td class="table-input"></td>
                                        <td class="table-input"><input type="text" placeholder="phone number" /></td>
                                        <td class="table-input"><input type="text" placeholder="field 1" /></td>
                                        <td class="table-input"><input type="text" placeholder="field 2" /></td>
                                        <td class="table-input"><input type="text" placeholder="field 3" /></td>
                                        <td class="table-input"><input type="text" placeholder="field 4" /></td>
                                        <td class="table-input"><input type="text" placeholder="field 5" /></td>
                                    </tr>
                                    <tr>
                                        <td class="center aligned collapsing">1</td>
                                        <td>254712345678</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                        <td>-</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>-->
        <ListDetails v-show="selectedList" ref="details" />
    
        </div>
        <CreateContactList />
        <EditContactList />
    </div>
</template>

<script>
    import loader from "@/components/loader";
    import store from "@/store";
    import bulkstore from "@/bulk/bulksms-state";
    import CreateContactList from "@/modals/contact-list-create";
    import EditContactList from "@/modals/contact-list-edit";
    import Dropzone from "dropzone";
    // import CreateContactList from "@/bulk/modals/contacts-list-create";
    
    import ListDetails from "./list-details";
    export default {
        data() {
            return {
                inboxzero: false,
                dataLists: [],
                dataListCount: 0,
                countN: 1,
                list_id: "",
                list_name: "",
                status: "",
                limit: 10,
                selectedKey: null,
                offset: 0,
                selectedList: '',
                order: "",
                showUploadSection: false,
                uploadFiles: null,
                processingUploadFile: false,
                //infinite scroll
                busy: false,
                totalContactLists: 0,
                loading: true,
            }
        },
        components: {
            ListDetails,
            loader,
            CreateContactList,
            EditContactList
        },
        mounted() {
            let vm = this;
            if (vm.$route.params.id != "" && !isNaN(vm.$route.params.id)) {
                   
                var listid = vm.$route.params.id;
                vm.selectedKey = listid;
                vm.getDetails(listid);
               // this.$router.push({name: 'ListDetails', params: { id: listid}});
            }
            $('.ui.dropdown').dropdown();
            $('.ui.progress').progress();
            vm.getContactList();
            this.$root.$on('refreshList',(data) => {
                vm.dataLists= [];
                vm.dataListCount= 0;
                vm.countN= 1;
                vm.list_id= "";
                vm.list_name= "";
                vm.status= "";
                vm.limit= 10;
                vm.offset= 0;
                vm.totalContactLists = 0;
                vm.selectedList='';
                vm.getContactList();

            });
            this.$root.$on('refreshSelected',(data) => {
               
               vm.dataLists= [];
                vm.dataListCount= 0;
                vm.countN= 1;
                vm.list_id= "";
                vm.list_name= "";
                vm.status= "";
                vm.limit= 10;
                vm.offset= 0;
                vm.totalContactLists = 0;
                vm.getContactList();
            });
            this.totalContactLists = 0;
            this.dataLists = [];
            this.selectedList = '';
            bulkstore.commit("setSelectedList", '');
            
        },
        methods: {
            createContactList() {
                $(".ui.modal#modal-create-contact-list").modal({
                    centered: false,
                    closable: true
                }).modal("show");
            },
            editContactList() {
                $(".ui.modal#modal-edit-contact-list").modal({
                    centered: false,
                    closable: true
                }).modal("show");
            },
            showApplySenderID() {
                $(".ui.modal#modal-apply-senderid").modal({
                    centered: false,
                    closable: true
                }).modal("show");
            },
            getContactList: function() {
                var vm = this;
                if (vm.totalContactLists === 0 || vm.totalContactLists >= ((vm.offset - 1) * vm.limit)) {
                    vm.loading = true;
                    vm.offset++;
                    $.post({
                        url: store.state.rootUrl + 'contact/get/list',
                        type: "POST",
                        data: JSON.stringify({
                            apiKey: this.$cookies.get("key"),
                            list_id: vm.list_id,
                            list_name: vm.list_name,
                            status: vm.status,
                            limit: vm.limit,
                            offset: vm.offset

                        }),
                        success: function(response, status, jQxhr) {
                            vm.loading = false;
                            if (response.data.data != "") {
                                vm.inboxzero = false;
                                //vm.dataLists = response.data.data;
                                vm.dataListCount = response.data.count;
                                vm.totalContactLists = response.data.data[0].total;
                                var totalContacts = 0;
                                var list_c = response.data.data;
    
                                for (var i = 0; i < list_c.length; i++) 
                                {
                                    totalContacts = totalContacts + parseInt(list_c[i].total, 10);
                                    vm.dataLists.push(list_c[i]);
                                    if(i==0){
                                       // vm.selectList(list_c[i]);
                                    }
                                    
                                }
                                bulkstore.commit("setContactList", vm.dataLists);
                            }
                            else if(vm.offset > 1){
                                vm.inboxzero = false;
                            } else {
                                vm.inboxzero = true;
                            }
                        },
                        error: function(jQxhr, status, error) {
                            vm.loading = false;
                            vm.dataLists = [];
                            bulkstore.commit("setContactList", []);
                        }
                    });
                }
            },
            getDetails(listid){
                let vm =this;
                $.post({
                    url: store.state.rootUrl + 'contact/get/list',
                    type: "POST",
                    data: JSON.stringify({
                        apiKey: this.$cookies.get("key"),
                        list_id: listid,
                        list_name: "",
                        status: "",
                        limit: "",
                        offset: ""

                    }),
                    success: function(response, status, jQxhr) {
                        var list_c = response.data.data;
                        vm.selectedList = list_c;
                        bulkstore.commit("setSelectedList", list_c);
                        vm.$refs.details.setListValue(list_c);
                    },
                    error: function(jQxhr, status, error) {
                    }
                });
            },
            selectList(list) {
                //console.log("am here "+JSON.stringify(list));
                this.selectedKey="";
                this.selectedList=[];
                this.$route.params.id ="";
                this.selectedKey = list.contact_groupId;
                this.selectedList = list;
                bulkstore.commit("setSelectedList", list);
                this.$refs.details.setListValue(list);
                if ($(window).width() < 640){
                this.$router.push({name: 'ListDetails', params: { id: list.contact_groupId}});
                }
            }
        }
    };
</script>


